module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('section', [_c('carousel', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    attrs: {
      "navigationEnabled": true,
      "navigationNextLabel": '',
      "navigationPrevLabel": '',
      "perPage": 1,
      "paginationActiveColor": '#f58466',
      "paginationColor": '#dedede',
      "navigationClickTargetSize": 5,
      "paginationPadding": 5,
      "paginationSize": 14
    }
  }, [_vm._l((_vm.props), function(slide) {
    return (_vm.props.length) ? [_c('slide', {
      staticClass: "slider-container"
    }, [_c('div', {
      staticClass: "bg-inside"
    }, [_c('div', {
      staticClass: "inside"
    }, [_c('div', {
      staticClass: "caption",
      domProps: {
        "innerHTML": _vm._s(slide.caption.value)
      }
    }), _vm._v(" "), (slide.button.value.length != 0 && slide.button_link.value.length != 0) ? _c('a', {
      staticClass: "btn_orange",
      attrs: {
        "href": slide.button_link.value
      }
    }, [_vm._v("\n  \t\t\t\t\t\t\t" + _vm._s(slide.button.value) + "\n\t\t\t\t\t\t\t")]) : _vm._e()])])])] : _vm._e()
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b15249fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider.vue
// module id = 1550
// module chunks = 0